import React from 'react';
import { Link } from 'react-router-dom';

// ==========================================
// DONNÉES DES ARTICLES DU BLOG
// Chaque nouvel article ajouté ici apparaît automatiquement
// sous forme de carte sur la page d'accueil du blog.
// ==========================================
const articles = [
  {
    slug: 'rgpd-nis2-iso27001-differences',
    publishDate: '2026-09-01',
    tag: 'Cybersécurité & Conformité',
    featured: true,
    title: 'RGPD, NIS2, ISO 27001 : quelles différences ?',
    chapo:
      "RGPD, NIS2, ISO 27001 : trois référentiels qui parlent tous de sécurité et de conformité, mais qui n'ont ni le même objectif, ni le même statut, ni le même périmètre. Le point pour savoir lesquels s'appliquent réellement à votre entreprise.",
  },
  {
    slug: 'cybersecurite-pme-guide-dirigeants',
    publishDate: '2026-09-08',
    tag: 'Cybersécurité',
    title: 'Cybersécurité PME : le guide complet pour les dirigeants',
    chapo:
      "Ransomware, phishing, fuite de données : les risques cyber ne concernent pas que les grandes entreprises. Ce guide fait le point sur ce qu'un dirigeant de PME doit savoir, sans jargon technique.",
  },
  {
    slug: 'qui-est-concerne-par-nis2',
    publishDate: '2026-09-10',
    tag: 'NIS2',
    title: 'Comment savoir si mon entreprise est concernée par NIS2 ?',
    chapo:
      "NIS2 ne s'applique pas à toutes les entreprises, mais le périmètre est plus large qu'on ne le pense. Secteurs concernés, critères de taille, sous-traitants : comment savoir si votre entreprise est dans le champ d'application.",
  },
  {
    slug: 'audit-cybersecurite-pme-guide-pratique',
    publishDate: '2026-09-15',
    tag: 'Audit & Diagnostic',
    title: 'Audit cybersécurité PME : le guide pratique',
    chapo:
      "Faire auditer sa cybersécurité peut sembler lourd et coûteux. Voici comment ça se passe concrètement, ce qu'un audit doit couvrir, et comment obtenir un premier diagnostic sans mobiliser toute votre équipe pendant des semaines.",
  },
  {
    slug: 'diagnostic-cybersecurite-a-quoi-sattendre',
    publishDate: '2026-09-17',
    tag: 'Audit & Diagnostic',
    title: "Diagnostic cybersécurité : à quoi s'attendre et comment ça marche",
    chapo:
      "Compte de bonne aventure ou vrai outil de pilotage ? Le déroulé étape par étape d'un diagnostic automatisé : questionnaire, score immédiat, rapport PDF, plan d'action sur quatre semaines.",
  },
  {
    slug: 'comment-evaluer-cybersecurite-pme',
    publishDate: '2026-09-22',
    tag: 'Audit & Diagnostic',
    title: 'Comment évaluer la cybersécurité de votre PME',
    chapo:
      "Quatre dimensions à regarder pour se faire une première idée de son niveau de protection : technique, organisationnelle, humaine et tiers/prestataires.",
  },
  {
    slug: 'checklist-cybersecurite-entreprise',
    publishDate: '2026-09-24',
    tag: 'Guides pratiques',
    title: 'Checklist cybersécurité entreprise : les points à vérifier',
    chapo:
      "Une checklist courte et concrète pour repérer rapidement les manques les plus fréquents en PME : accès, sauvegardes, postes de travail, sensibilisation, prestataires, réponse à incident.",
  },
  {
    slug: 'securite-des-donnees-rgpd',
    publishDate: '2026-09-29',
    tag: 'RGPD',
    title: 'La sécurité des données selon le RGPD : ce que le texte impose vraiment',
    chapo:
      "Le RGPD n'impose pas une liste fixe d'outils, mais un raisonnement proportionné au risque. Ce que couvrent concrètement les mesures attendues, et l'obligation de notification en 72 heures.",
  },
  {
    slug: 'gestion-des-risques-cybersecurite-methode-commune',
    publishDate: '2026-10-01',
    tag: 'Cybersécurité & Conformité',
    title: 'Gestion des risques cybersécurité : la méthode commune à RGPD, NIS2 et ISO 27001',
    chapo:
      "Les trois référentiels emploient des vocabulaires différents mais reposent sur la même méthode de gestion des risques. La comprendre permet d'avancer sur les trois fronts en même temps.",
  },
  {
    slug: 'nis2-pme-ce-qui-change',
    publishDate: '2026-10-06',
    tag: 'NIS2',
    title: 'NIS2 pour les PME : ce qui change concrètement',
    chapo:
      "Une fois votre entreprise identifiée comme concernée par NIS2 : gouvernance, gestion des risques, déclaration des incidents, sécurité de la chaîne d'approvisionnement, sanctions.",
  },
  {
    slug: 'iso27001-pme-accessible',
    publishDate: '2026-10-08',
    tag: 'ISO 27001',
    title: 'ISO 27001 pour les PME : est-ce accessible sans grosse structure ?',
    chapo:
      "ISO 27001 a la réputation d'être réservée aux grandes entreprises. La norme est en réalité conçue pour être proportionnée à la taille de l'organisation qui l'applique.",
  },
  {
    slug: 'ransomware-entreprise-comprendre-se-proteger',
    publishDate: '2026-10-13',
    tag: 'Cybersécurité',
    title: "Ransomware en entreprise : comprendre la menace et s'en protéger",
    chapo:
      "Comment un ransomware s'introduit, ce qui se passe pendant l'attaque, pourquoi ne pas payer la rançon, et les mesures concrètes de prévention.",
  },
  {
    slug: 'phishing-entreprise-reconnaitre-prevenir',
    publishDate: '2026-10-15',
    tag: 'Cybersécurité',
    title: 'Phishing en entreprise : reconnaître et prévenir les attaques',
    chapo:
      "Phishing classique, spear phishing, fraude au président, smishing : les formes à connaître, les signaux d'alerte, et les bons réflexes de prévention.",
  },
  {
    slug: 'que-faire-apres-cyberattaque',
    publishDate: '2026-10-20',
    tag: 'Cybersécurité',
    title: 'Que faire après une cyberattaque : la marche à suivre',
    chapo:
      "Les premiers réflexes, les obligations de notification, la communication à adopter, et comment préparer cette réponse avant qu'un incident ne survienne.",
  },
  {
    slug: 'erreurs-cybersecurite-frequentes-pme',
    publishDate: '2026-10-22',
    tag: 'Cybersécurité',
    title: 'Les erreurs de cybersécurité les plus fréquentes en PME',
    chapo:
      "Huit erreurs récurrentes, souvent connues mais rarement corrigées, qui exposent la majorité des PME bien plus que des attaques sophistiquées.",
  },
  {
    slug: 'securite-informatique-entreprise-fondamentaux',
    publishDate: '2026-10-27',
    tag: 'Cybersécurité',
    title: 'Sécurité informatique en entreprise : les fondamentaux à connaître',
    chapo:
      "Défense en profondeur, gestion des identités, segmentation réseau, patch management : les principes techniques pour les DSI et responsables informatiques.",
  },
  {
    slug: 'rgpd-cybersecurite-ce-que-toute-entreprise-doit-savoir',
    publishDate: '2026-10-29',
    tag: 'RGPD',
    title: 'RGPD et cybersécurité : ce que toute entreprise doit savoir',
    chapo:
      "Registre des traitements, information des personnes, droits, sous-traitance, durées de conservation, DPO : le tour d'horizon des obligations RGPD au-delà de la sécurité.",
  },
  {
    slug: 'violation-donnees-personnelles-obligations-procedure',
    publishDate: '2026-11-03',
    tag: 'RGPD',
    title: 'Violation de données personnelles : obligations et procédure à suivre',
    chapo:
      "Qu'est-ce qu'une violation au sens du RGPD, l'obligation de notification en 72 heures, quand informer les personnes concernées, et comment s'y préparer en amont.",
  },
  {
    slug: 'audit-rgpd-entreprise-comment-realiser',
    publishDate: '2026-11-05',
    tag: 'RGPD',
    title: 'Audit RGPD en entreprise : comment le réaliser',
    chapo:
      "Ce qu'un audit RGPD examine précisément, ses étapes, et pourquoi il est complémentaire d'un audit cybersécurité plutôt qu'un doublon.",
  },
  {
    slug: 'audit-nis2-comment-preparer-entreprise',
    publishDate: '2026-11-10',
    tag: 'NIS2',
    title: 'Audit NIS2 : comment préparer votre entreprise',
    chapo:
      "Confirmer votre statut, évaluer votre gestion des risques, votre gouvernance, votre capacité de déclaration d'incidents et votre chaîne d'approvisionnement.",
  },
  {
    slug: 'ia-risque-cybersecurite-entreprise',
    publishDate: '2026-11-12',
    tag: 'IA & Cybersécurité',
    title: "L'IA comme risque cybersécurité : ce que les entreprises doivent intégrer",
    chapo:
      "Au-delà de la sécurisation des usages de ChatGPT, l'IA devient une composante technique de vos systèmes d'information, avec ses propres risques à intégrer dans votre cybersécurité globale.",
  },
  {
    slug: 'risques-ia-panorama',
    publishDate: '2026-11-17',
    tag: 'IA & Cybersécurité',
    title: 'Risques cyber liés à l\'intelligence artificielle : le panorama',
    chapo:
      "Attaques ciblant les systèmes d'IA, prompt injection, fuite de données, dépendance aux fournisseurs : les principales familles de risques à connaître.",
  },
  {
    slug: 'gouvernance-systemes-ia-entreprise',
    publishDate: '2026-11-19',
    tag: 'IA & Cybersécurité',
    title: "Gouvernance des systèmes d'IA : par où commencer",
    chapo:
      "Désigner un pilote, cartographier les systèmes déjà en place, formaliser une politique claire : les bases d'une gouvernance IA qui ne reste pas lettre morte.",
  },
  {
    slug: 'risques-donnees-ia-entreprise',
    publishDate: '2026-11-24',
    tag: 'IA & Cybersécurité',
    title: "Risques liés aux données utilisées par les IA de l'entreprise",
    chapo:
      "Données envoyées à un système d'IA, données de personnalisation, risque de ré-identification : ce qu'il faut vérifier avant de faire confiance à un système d'IA.",
  },
  {
    slug: 'ai-act-cybersecurite-entreprise',
    publishDate: '2026-11-26',
    tag: 'IA & Cybersécurité',
    title: 'AI Act et cybersécurité : ce que ça change pour votre entreprise',
    chapo:
      "Classification par niveau de risque, lien avec la cybersécurité, et ce que cela signifie concrètement pour une PME utilisatrice de systèmes d'IA tiers.",
  },
  {
    slug: 'attaques-systemes-ia',
    publishDate: '2026-12-01',
    tag: 'IA & Cybersécurité',
    title: "Attaques contre les systèmes d'IA : ce qu'il faut savoir",
    chapo:
      "Empoisonnement de données, extraction de modèle, manipulation d'entrée, prompt injection : les menaces spécifiques aux systèmes d'IA pour les DSI et RSSI.",
  },
  {
    slug: 'prompt-injection-comprendre-proteger',
    publishDate: '2026-12-03',
    tag: 'IA & Cybersécurité',
    title: 'Prompt injection : comprendre cette faille et s\'en protéger',
    chapo:
      "Le principe de cette faille propre aux systèmes conversationnels, un exemple concret, et les mesures qui réduisent significativement le risque.",
  },
  {
    slug: 'fuite-donnees-systemes-ia',
    publishDate: '2026-12-08',
    tag: 'IA & Cybersécurité',
    title: "Fuite de données via les systèmes d'IA : comment ça arrive",
    chapo:
      "Droits d'accès trop larges, mémorisation entre sessions, intégrations tierces mal maîtrisées : les scénarios de fuite propres aux systèmes d'IA intégrés.",
  },
  {
    slug: 'securite-api-modeles-ia',
    publishDate: '2026-12-10',
    tag: 'IA & Cybersécurité',
    title: 'Sécurité des API et des modèles IA en entreprise',
    chapo:
      "Gestion des clés API, limitation des débits, validation des entrées et sorties, isolation des environnements : les points de contrôle techniques essentiels.",
  },
  {
    slug: 'gestion-fournisseurs-ia',
    publishDate: '2026-12-15',
    tag: 'IA & Cybersécurité',
    title: 'Gestion des fournisseurs IA : les points de contrôle essentiels',
    chapo:
      "Hébergement des données, usage à des fins d'entraînement, garanties contractuelles, réversibilité : la grille d'évaluation à appliquer à chaque fournisseur d'IA.",
  },
  {
    slug: 'evaluer-risques-ia-methode',
    publishDate: '2026-12-17',
    tag: 'IA & Cybersécurité',
    title: 'Évaluer les risques IA de votre entreprise : la méthode',
    chapo:
      "Cartographier vos usages, qualifier leur sensibilité, croiser avec les familles de risques connues : une méthode en cinq étapes pour prioriser sans se disperser.",
  },
  {
    slug: 'integrer-ia-iso27001',
    publishDate: '2027-01-05',
    tag: 'IA & Cybersécurité',
    title: "Intégrer l'IA dans une démarche ISO 27001",
    chapo:
      "Élargir votre cartographie des actifs, étendre votre analyse de risques, adapter vos politiques existantes : l'IA comme composante de votre SMSI plutôt qu'un angle mort.",
  },
  {
    slug: 'ia-rgpd-nis2-articuler',
    publishDate: '2027-01-07',
    tag: 'IA & Cybersécurité',
    title: 'IA, RGPD, NIS2 : comment articuler les trois exigences',
    chapo:
      "L'IA ne crée pas un référentiel isolé : elle fait évoluer l'application de vos obligations RGPD et NIS2 existantes, en plus de l'AI Act qui s'y ajoute.",
  },
  {
    slug: 'supervision-usages-ia-entreprise',
    publishDate: '2027-01-12',
    tag: 'IA & Cybersécurité',
    title: 'Contrôle et supervision des usages IA en entreprise',
    chapo:
      "Le prolongement opérationnel de la gouvernance : tenir un inventaire vivant, auditer périodiquement, définir des indicateurs, prévoir un canal de signalement.",
  },
];

const styles = {
  page: {
    fontFamily: '"Inter", sans-serif',
    color: '#0B1F3A',
    background: '#FFFFFF',
    minHeight: '100vh',
  },
  hero: {
    background: '#0B1F3A',
    color: '#FFFFFF',
    padding: '80px 20px',
    textAlign: 'center',
  },
  heroInner: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  badge: {
    display: 'inline-block',
    background: 'rgba(255,255,255,0.1)',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '24px',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  h1: {
    fontSize: '42px',
    fontWeight: 800,
    margin: '0 0 16px 0',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: '18px',
    color: '#F5F7FA',
    opacity: 0.9,
  },
  section: {
    background: '#F5F7FA',
    padding: '60px 20px',
  },
  grid: {
    maxWidth: '1000px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px',
  },
  card: {
    flex: '1 1 320px',
    background: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(11, 31, 58, 0.06)',
    padding: '28px',
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    color: '#0B1F3A',
  },
  cardFeatured: {
    border: '2px solid #6C5CE7',
  },
  featuredPill: {
    display: 'inline-block',
    background: '#6C5CE7',
    color: '#FFFFFF',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: '14px',
    alignSelf: 'flex-start',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  tagPill: {
    display: 'inline-block',
    background: '#F5F7FA',
    color: '#6C5CE7',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: '14px',
    alignSelf: 'flex-start',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '10px',
    lineHeight: 1.3,
  },
  cardChapo: {
    fontSize: '15px',
    color: '#0B1F3A',
    opacity: 0.75,
    lineHeight: 1.6,
    marginBottom: '18px',
    flex: 1,
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px',
    color: '#94A3B8',
  },
  readLink: {
    color: '#6C5CE7',
    fontWeight: 'bold',
  },
};


const MOIS_FR = [
  'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
];

function formatDateFR(isoDate) {
  const d = new Date(isoDate + 'T00:00:00');
  return `${d.getDate()} ${MOIS_FR[d.getMonth()]} ${d.getFullYear()}`;
}

// N'affiche que les articles dont la date de publication est atteinte,
// du plus récent au plus ancien.
function getPublishedArticles() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return articles
    .filter((article) => new Date(article.publishDate + 'T00:00:00') <= today)
    .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
}

function Blog() {
  return (
    <div style={styles.page}>
      <header style={styles.hero}>
        <div style={styles.heroInner}>
          <div style={styles.badge}>📚 Blog Audit Cyber Pro</div>
          <h1 style={styles.h1}>
            Cybersécurité, RGPD, NIS2, ISO 27001 : nos guides pour les dirigeants de PME/ETI
          </h1>
          <p style={styles.subtitle}>
            Des articles concrets pour comprendre vos obligations et évaluer votre niveau réel de protection —
            sans jargon inutile.
          </p>
        </div>
      </header>

      <section style={styles.section}>
        <div style={styles.grid}>
          {getPublishedArticles().map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              style={{
                ...styles.card,
                ...(article.featured ? styles.cardFeatured : {}),
              }}
            >
              {article.featured && <span style={styles.featuredPill}>🔑 Article clé</span>}
              <span style={styles.tagPill}>{article.tag}</span>
              <h2 style={styles.cardTitle}>{article.title}</h2>
              <p style={styles.cardChapo}>{article.chapo}</p>
              <div style={styles.cardFooter}>
                <span>{formatDateFR(article.publishDate)}</span>
                <span style={styles.readLink}>Lire l'article →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Blog;
